import React, { useState, useContext } from 'react';
import callAPI from '../helpers/callAPI';
import { SystemMessageContext } from '../context/SystemMessageContext'

export default function useRunSystemJob(){

    const [runSystemJobConfirm, setRunSystemJobConfirm] = useState(false);
    const { showSystemMessage } = useContext(SystemMessageContext)

    const runSystemJob = async (task, callback) => {
        let result = await callAPI( `systemJob/run/${task.job_id}`,'PUT');

        if (result.success) {
            showSystemMessage("success", "Job will run in the next 1-2 minutes.");
            callback()
            setRunSystemJobConfirm(false);
        } else {
            showSystemMessage("error", result.errors.message);
        }

        setRunSystemJobConfirm(false);
    }

    return { runSystemJobConfirm, setRunSystemJobConfirm, runSystemJob }

}

